/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Transcript-derived content that a provider attached to a submitted prompt, such as Claude Code @file and @directory mentions.
 */
export type HookPromptAttachmentEntry = {
  /**
   * Provider attachment kind, such as file or directory.
   */
  attachmentKind: string;
  /**
   * Attachment text visible to the model.
   */
  content: string;
  /**
   * Provider display path for the attachment, when available.
   */
  displayPath?: string | undefined;
  /**
   * Provider transcript entry UUID. Used as the stable attachment identifier.
   */
  entryUuid: string;
  /**
   * Absolute provider-reported file or directory path, when available.
   */
  filePath?: string | undefined;
  /**
   * Number of lines included in the attachment window, when reported.
   */
  numLines?: number | undefined;
  /**
   * Prompt identifier of the user turn this attachment belongs to, when the transcript parent chain resolves.
   */
  promptId?: string | undefined;
  /**
   * Lowercase hex SHA-256 of the trimmed prompt text stored for the parent user message, when available.
   */
  promptSha256?: string | undefined;
  /**
   * First one-based source line included in the attachment window, when reported.
   */
  startLine?: number | undefined;
  /**
   * Provider transcript timestamp for this attachment, when available.
   */
  timestamp?: string | undefined;
  /**
   * Total source file lines, when reported.
   */
  totalLines?: number | undefined;
};

/** @internal */
export type HookPromptAttachmentEntry$Outbound = {
  attachment_kind: string;
  content: string;
  display_path?: string | undefined;
  entry_uuid: string;
  file_path?: string | undefined;
  num_lines?: number | undefined;
  prompt_id?: string | undefined;
  prompt_sha256?: string | undefined;
  start_line?: number | undefined;
  timestamp?: string | undefined;
  total_lines?: number | undefined;
};

/** @internal */
export const HookPromptAttachmentEntry$outboundSchema: z.ZodMiniType<
  HookPromptAttachmentEntry$Outbound,
  HookPromptAttachmentEntry
> = z.pipe(
  z.object({
    attachmentKind: z.string(),
    content: z.string(),
    displayPath: z.optional(z.string()),
    entryUuid: z.string(),
    filePath: z.optional(z.string()),
    numLines: z.optional(z.int()),
    promptId: z.optional(z.string()),
    promptSha256: z.optional(z.string()),
    startLine: z.optional(z.int()),
    timestamp: z.optional(z.string()),
    totalLines: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      attachmentKind: "attachment_kind",
      displayPath: "display_path",
      entryUuid: "entry_uuid",
      filePath: "file_path",
      numLines: "num_lines",
      promptId: "prompt_id",
      promptSha256: "prompt_sha256",
      startLine: "start_line",
      totalLines: "total_lines",
    });
  }),
);

export function hookPromptAttachmentEntryToJSON(
  hookPromptAttachmentEntry: HookPromptAttachmentEntry,
): string {
  return JSON.stringify(
    HookPromptAttachmentEntry$outboundSchema.parse(hookPromptAttachmentEntry),
  );
}
